import { unsubscribeSubscription } from '@src/api/emailSubscriptions';
import { message } from 'antd';
import { useResetAtom } from 'jotai/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSubscriptionAtom, editSubscriptionAtom, emailsToUnsubscribeAtom } from './atoms';

export const useResetPanelAtoms = () => {
  const resetCreateFormAtom = useResetAtom(createSubscriptionAtom);
  const resetEditFormAtom = useResetAtom(editSubscriptionAtom);
  const resetEmailsToUnsubscribeAtom = useResetAtom(emailsToUnsubscribeAtom);

  const reset = () => {
    resetCreateFormAtom();
    resetEditFormAtom();
    resetEmailsToUnsubscribeAtom();
  };

  return {
    reset,
    resetCreateFormAtom,
    resetEditFormAtom,
    resetEmailsToUnsubscribeAtom,
  };
};

export const useUnsubscribeEmail = () => {
  const queryClient = useQueryClient();
  const resetAtoms = useResetPanelAtoms();

  return useMutation(
    (emailIds: string[]) => {
      return unsubscribeSubscription({ emails: emailIds });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['email-subscriptions-list']);
        resetAtoms.resetEmailsToUnsubscribeAtom();
      },
      onError: () => {
        message.error('There was an error unsubscribing. Please try again later.');
      },
    },
  );
};
